import React from "react";
import DOMPurify from "dompurify";


function getInnerText(el, selector, defaultContent) {
    let innerText = el.querySelector(selector)
        ? el.querySelector(selector).innerText.trim()
        : defaultContent;
    return innerText == "undefined" ? defaultContent : innerText;
}

function getInnerHTML(el, selector, defaultContent) {
    let innerHTML = el.querySelector(selector)
        ? el.querySelector(selector).innerHTML
        : defaultContent;
    return innerHTML == "undefined" ? defaultContent : innerHTML;
}

export function generateSuccessElement(formDescription, config, status, form) {
    const successFullDialogTitle = getInnerText(form.props.config, "successFullDialogTitle", "Thanks you for you submission!");
    const successFullDialogContent = getInnerHTML(form.props.config, "successFullDialogContent", "It is very important to hear from you to improve your product!");
    const safeSuccessFullDialogContent = DOMPurify.sanitize(successFullDialogContent || '', { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
    const successConfirmText = getInnerHTML(form.props.config, "successConfirmText", "Okay");
    const successConfirmLink = getInnerHTML(form.props.config, "successConfirmLink", null);

    const successCallBack = function(){

        sendEvent("onFormSuccessConfirm", form);

        if(successConfirmLink){
            window.location = successConfirmLink
        }else{
            // reset form
            form.resetForm();
        }



    }

    return <div className="alert alert-success pubhub-smartsheet-form-success" role="alert">
        <h3>{successFullDialogTitle}</h3>
        <p className="hint">{safeSuccessFullDialogContent}</p>
        <button type="submit" className="btn btn-secondary" onClick={successCallBack}>{successConfirmText}</button>
    </div>
}

export function generateErrorElement(formDescription, config, status, form) {
    return <div className="alert alert-warning" role="alert">
        <h3>Something goes wrong !</h3>
        <p className="hint">Please try again later</p>
        <button type="submit" className="btn btn-secondary" onClick={form.resetForm}>Retry</button>
    </div>

}

export function generateActionElement(formDescription, config, status, form) {

    let actions = <button type="submit" className="btn btn-primary disabled">Submit</button>

    if (status == "loading") {
        actions = <span className="pubhub-loading-s"></span>
    }

    if (status == "valid") {
        actions = <button type="submit" className="btn btn-primary cursor-pointer"
                          onClick={form.submitForm}>Submit</button>
    }

    return <div className="row  pubhub-smartsheet-form-action ">
        <div className="col justify-content-end d-flex">
            {actions}
        </div>
    </div>
}

export function sendEvent(eventName, form) {

    const _event = new CustomEvent(eventName, {
        detail: {
            data: form.formData,
            form: form
        },
        bubbles: true,
        cancelable: true
    });
    form.formRoot.dispatchEvent(_event);
}
